import React from "react";

const SDVideo = ({ video }) => {
  return (
    <div className="sd-video-container">
      <iframe
        width="560"
        height="315"
        src={video}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default SDVideo;
